import { ca } from '@cian/analytics';

export function trackNavigationToFlats() {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'to_flats',
    label: 'empty_list',
    page: {
      siteType: 'desktop',
      pageType: 'ListingCompare',
    },
  });
}
